/* src/app/components/controls/sem-one-to-many-container/one-to-many-section/one-to-many-section.component.css */
.o2m-string-link,
.o2m-string-link:visited,
.o2m-string-link:hover,
.o2m-string-link:active {
  position: relative;
  z-index: 1;
  text-decoration: underline !important;
  color: #0000ee !important;
  cursor: pointer;
}
/*# sourceMappingURL=one-to-many-section.component.css.map */
